<template>
  <img class="picture__img" :src="src" />
</template>

<style scoped>
.picture__img {
  width: 100%;
  color: #ffffff;
  background-color: #000000;
}

@media screen and (max-width: 600px) {
  .picture__img {
    width: 100%;
  }
}
</style>

<script>
export default {
  title: "Picture",
  props: {
    src: String
  }
};
</script>
